import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
// import "./notification-slider.css"
import "./slider.css"


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const SliderPure = (props) => {
    const { t } = useTranslation();
    const {
        initializeNotification,
        showNotification,
        toggleNotification,
        title,
        options,
        icon,
        showEndPanel
    } = props;
    const [scrollY, setScrollY] = useState(60)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 60) {
                setScrollY(0)
            } else {
                setScrollY(60)
            }
        });
    }, [window.scrollY])

    const sliderRef = useRef(null);

    function handleClickOutside(event) {
        if (
            showNotification && sliderRef.current &&
            !sliderRef.current.contains(event.target) &&
            !event.target.classList.contains('k-avatar-image') &&
            !event.target.classList.contains('config-icon')
        ) {
            toggleNotification(false)
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showNotification]);

    return (
        <div ref={sliderRef} className={`${initializeNotification ? "" : "notificationPanel hide"}`}>
            <div style={{ marginTop: scrollY }} className={`notificationPanel ${showNotification ? "open" : ""}`}>
                {/* Header Verde */}
                <div className="notificationPanel-header">
                    <p className="notificationPanel-header-title">
                        {title}
                    </p>
                </div>

                <ul className="slider-slidebar-menu">
                    {options && options.map((menuItem, index) => (
                        <li key={index} className="menu-item">
                            {React.cloneElement(menuItem, {
                                onClick: () => {
                                    menuItem.props.onClick();
                                    toggleNotification(false)
                                },
                                className: "menu-item-button"
                            })}
                        </li>
                    ))}
                </ul>
                {showEndPanel}
            </div>
        </div>
    );
};


//Elemento Dropdown para Notificaciones.
export const Dropdown = ({ trigger, menu }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    return (
        <div className="dropdown">
            {React.cloneElement(trigger, {
                onClick: handleOpen,
            })}
            {open ? (
                <ul className="menu">
                    {menu.map((menuItem, index) => (
                        <li key={index} className="menu-item">
                            {React.cloneElement(menuItem, {
                                onClick: () => {
                                    menuItem.props.onClick();
                                    setOpen(false);
                                },
                            })}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};
export { SliderPure as default };
